import React, { useState } from "react";
import "../assets/css/Groups.css";

const AddGroupsList = () => {
  const [search, setSearch] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    city: "",
    branch: "",
    status: "ACTIVE",
  });

  const initialData = [
    { code: "IJ202515", name: "RAM BANERJEE", city: "BURDWAN", branch: "KOLKATA - DALHOUSIE", status: "ACTIVE" },
    { code: "IJ202514", name: "RICHLIFE MIRZAPUR GROUP", city: "MIRZAPUR", branch: "BAREILLY", status: "ACTIVE" },
    { code: "IJ202513", name: "HFDHUDU", city: "DHRHRHRH", branch: "ROSERA BRANCH", status: "ACTIVE" },
  ];

  const [tableData, setTableData] = useState(initialData);

  const filteredData = tableData.filter(
    (item) =>
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.branch.toLowerCase().includes(search.toLowerCase()) ||
      item.city.toLowerCase().includes(search.toLowerCase())
  );

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newGroup = {
      code: "IJ" + (Math.floor(Math.random() * 900000) + 100000),
      ...formData,
    };
    setTableData([newGroup, ...tableData]);
    setShowPopup(false);
    setFormData({ name: "", number: "", city: "", branch: "", status: "ACTIVE" });
  };

  const toggleStatus = (code) => {
    const updatedData = tableData.map((item) =>
      item.code === code
        ? { ...item, status: item.status === "ACTIVE" ? "INACTIVE" : "ACTIVE" }
        : item
    );
    setTableData(updatedData);
  };

  return (
    <div className="AddGroupsList-container">
      <div className="AddGroupsList-header">
        <h2>GROUP</h2>
      </div>

      <div className="AddGroupsListfilter-section">
        <label>FILTER BY</label>
        <div className="AddGroupsListfilter-input">
          <label>Branch</label>
          <select>
            <option value="">Select Branch</option>
            <option>KOLKATA - DALHOUSIE</option>
            <option>BAREILLY</option>
            <option>ROSERA BRANCH</option>
          </select>
        </div>
      </div>

      <div className="AddGroupsListtable-section">
        <div className="AddGroupsListtable-header">
          <h3>COLLECTION CENTER LIST</h3>
          <button
            className="AddGroupsListadd-btn"
            onClick={() => setShowPopup(!showPopup)}
          >
            + Add New
          </button>
        </div>

        <div className="AddGroupsListtable-controls">
          <select>
            <option>10</option>
            <option>25</option>
            <option>50</option>
          </select>
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="AddGroupsListtable-responsive">
          <table>
            <thead>
              <tr>
                <th>SR. NO</th>
                <th>CODE</th>
                <th>NAME</th>
                <th>CITY/VILLAGE</th>
                <th>BRANCH</th>
                <th>STATUS</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row, index) => (
                <tr key={row.code}>
                  <td>{index + 1}</td>
                  <td>{row.code}</td>
                  <td>{row.name}</td>
                  <td>{row.city}</td>
                  <td>{row.branch}</td>
                  <td>
                    <span
                      className={`AddGroupsListstatus ${row.status.toLowerCase()}`}
                      onClick={() => toggleStatus(row.code)}
                    >
                      {row.status}
                    </span>
                  </td>
                  <td>
                    <button className="AddGroupsListtask-btn">Task ▾</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Inline Popup beside SR. CODE */}
          {showPopup && (
            <div className="inline-popup">
              <h4>Add New Group</h4>
              <form onSubmit={handleSubmit} className="inlinepopup-form-grid">
                <div className="inlineform-group">
                  <label>Branch Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="inlineform-group">
                  <label>Group Name</label>
                  <input
                    type="text"
                    name="number"
                    value={formData.number}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="inlineform-group">
                  <label>Address</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="inlineform-group">
                  <label>City/Village Name</label>
                  <input
                    type="text"
                    name="branch"
                    value={formData.branch}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="inlineform-group">
                  <label>Collection Time</label>
                  <input
                    type="text"
                    name="collectionTime"
                    value={formData.collectionTime || ""}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="inlineform-group">
                  <label>Collection Day</label>
                  <input
                    type="text"
                    name="collectionDay"
                    value={formData.collectionDay || ""}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="inlineform-group">
                  <label>Status</label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option>ACTIVE</option>
                    <option>INACTIVE</option>
                  </select>
                </div>

                <div className="inlinepopup-btns">
                  <button type="submit" className="inlinepopup-save">Save Group</button>
                  <button
                    type="button"
                    className="inlinepopup-cancel"
                    onClick={() => setShowPopup(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="inlinepopup-reset"
                    onClick={() =>
                      setFormData({ name: "", number: "", city: "", branch: "", status: "ACTIVE" })
                    }
                  >
                    Reset
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddGroupsList;
